import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";
import { X } from "lucide-react";
const OilCheck = ({
  onNext,
  onBack,
  MaintainanceData,
  BookingData,
  setCount,
  ImageLink,
  cardata,
  FromComeData,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [oilData, setOilData] = useState({
    oilLevel: "",
    oilQuality: "",
    oilAdded: "",
    oilChangedBy: "",
    howmanydays: "",
    otherOilChangedBy: "",
    picture_close_oil: null,
    picture_close_oil_name: "",
  });
  const staffData = ["roberto", "marcus", "cheemal", "other"];

  useEffect(() => {
    const staffName = MaintainanceData.oil_changed_by?.toLowerCase();
    const isStaffMatched = staffName && staffData.includes(staffName);

    setOilData({
      oilLevel: MaintainanceData.oil_level,
      oilQuality: MaintainanceData.oil_quantity,
      oilAdded: MaintainanceData.oil_added_quantity,
      oilChangedBy: isStaffMatched ? MaintainanceData.oil_changed_by : "other",
      // oilChangedBy: staffName
      //   ? isStaffMatched
      //     ? MaintainanceData.oil_changed_by
      //     : "other"
      //   : "",
      howmanydays: MaintainanceData.howmanydays,
      otherOilChangedBy: !isStaffMatched ? MaintainanceData.oil_changed_by : "",
      picture_close_oil_name: MaintainanceData.picture_of_closed_oil,
    });
  }, [MaintainanceData]);

  const [errors, setErrors] = useState({
    oilLevel: false,
    oilQuality: false,
    oilAdded: false,
    oilChangedBy: false,
    howmanydays: false,
    otherOilChangedBy: false,
    picture_close_oil: false,
  });

  const handleChange = (field, value) => {
    setOilData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: false,
    }));
  };
  // console.log(oilData.picture_close_oil, "OilImg");
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadImageserver(file);
    }
  };
  const removeImage = () => {
    setOilData((prevData) => ({
      ...prevData,
      picture_close_oil: null,
      picture_close_oil_name: "",
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      picture_close_oil: false,
    }));
    document.getElementById("imageInput").value = "";
  };

  const uploadImageserver = async (file) => {
    const fd = new FormData();
    fd.append("image", file);
    await server_post_data(upload_image_to_folder, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setOilData((prevData) => ({
            ...prevData,
            picture_close_oil: file, // Store the uploaded image file
            picture_close_oil_name: Response.data.message.image_uploaded, // Store the uploaded image file
          }));
          // Remove error for picture_close_oil if file is uploaded
          setErrors((prevErrors) => ({
            ...prevErrors,
            picture_close_oil: false,
          }));
        }
      })
      .catch((error) => {});
  };

  const handleValidation = () => {
    let newErrors = { ...errors };
    newErrors.oilLevel = oilData.oilLevel === "";
    newErrors.oilQuality = oilData.oilQuality === "";
    // newErrors.howmanydays =
    //   oilData.howmanydays === "" || oilData.howmanydays === null;
    if (oilData.oilQuality === "changed") {
      newErrors.oilAdded = oilData.oilAdded === "";
      newErrors.oilChangedBy = oilData.oilChangedBy === "";
      if (
        oilData.oilChangedBy === "other" &&
        oilData.otherOilChangedBy === ""
      ) {
        newErrors.otherOilChangedBy = true;
      } else {
        newErrors.otherOilChangedBy = false;
      }
    }
    newErrors.picture_close_oil = oilData.picture_close_oil === null;
    setErrors(newErrors);

    return Object.values(newErrors).every((error) => !error);
  };
  // console.log(oilData, "oilData");
  const handleNext = async () => {
    if (handleValidation()) {
      setshowLoaderAdmin(true);

      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      // daysSinceLastCheck

      fd.append("oil_level", oilData.oilLevel);
      fd.append("oil_quantity", oilData.oilQuality);
      // fd.append("howmanydays", oilData.howmanydays);
      fd.append("howmanydays", null);
      fd.append("oil_added_quantity", oilData.oilAdded);
      fd.append("picture_close_oil", oilData.picture_close_oil);

      // oilChangedBy
      if (oilData.oilChangedBy === "other" && oilData.otherOilChangedBy) {
        fd.append("oil_changed_by", oilData.otherOilChangedBy);
      } else {
        fd.append("oil_changed_by", oilData.oilChangedBy);
      }

      fd.append("picture_of_closed_oil", oilData.picture_close_oil_name);
      fd.append("step_for_maintenance", 2);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);
      await server_post_data(maintainance_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            onNext();
            setCount(3);
          }
          setshowLoaderAdmin(false);
        })
        .catch(() => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
  };

  return (
    <>
      <div className="oil-check-container">
        <div className="section">
          <div className="row">
            {/* <h5>
              How Many Days
              <span className="mandory_field">*</span>
            </h5> */}

            {/* <div className="col-md-6 mb-3">
              <input
                type="number"
                className="form-control custmInput"
                placeholder="Enter Days here..."
                defaultValue={oilData.howmanydays}
                onChange={(e) =>
                  setOilData({ ...oilData, howmanydays: e.target.value })
                }
                onInput={(e) => {
                  if (e.target.value.length > 2) {
                    e.target.value = e.target.value.slice(0, 2);
                  }
                }}
              />

              {errors.howmanydays && (
                <span className="error-text">This field is required</span>
              )}
            </div> */}
          </div>
        </div>

        <div className="section">
          <h5>
            Oil Level: <span className="mandory_field">*</span>
          </h5>
          {errors.oilLevel && (
            <span className="error-text">This field is required.</span>
          )}
          <div className="row">
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilLevel === "good" ? "active goodActive" : ""
                }`}
                onClick={() => handleChange("oilLevel", "good")}
              >
                Good
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilLevel === "low" ? "active lowActive" : ""
                }`}
                onClick={() => handleChange("oilLevel", "low")}
              >
                Low
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilLevel === "veryLow" ? "active veryLowActive" : ""
                }`}
                onClick={() => handleChange("oilLevel", "veryLow")}
              >
                Very Low
              </button>
            </div>
          </div>
        </div>

        <div className="section">
          <h5>
            Oil Quality: <span className="mandory_field">*</span>
          </h5>
          {errors.oilQuality && (
            <span className="error-text">This field is required.</span>
          )}
          <div className="row">
            <div className="col-sm mb-2">
              <button
                className={`btn ${
                  oilData.oilQuality === "clean"
                    ? "cleanActive"
                    : "btn-outline-secondary"
                } w-100`}
                onClick={() => handleChange("oilQuality", "clean")}
              >
                Clean
              </button>
            </div>
            <div className="col-sm mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilQuality === "littleDark" ? "active lowActive" : ""
                }`}
                onClick={() => handleChange("oilQuality", "littleDark")}
              >
                Little Dark
              </button>
            </div>
            <div className="col-sm mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilQuality === "dark" ? "active veryLowActive" : ""
                }`}
                onClick={() => handleChange("oilQuality", "dark")}
              >
                Dark
              </button>
            </div>
            <div className="col-sm mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilQuality === "changedNextTime" ? "active" : ""
                }`}
                onClick={() => handleChange("oilQuality", "changedNextTime")}
              >
                Changed Next Time
              </button>
            </div>
            <div className="col-sm mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  oilData.oilQuality === "changed" ? "active cleanActive" : ""
                }`}
                onClick={() => handleChange("oilQuality", "changed")}
              >
                Changed
              </button>
            </div>
          </div>
        </div>

        {oilData.oilQuality === "changed" && (
          <>
            <div className="section">
              <h5>
                Oil Added (Quantity in Quarts):{" "}
                <span className="mandory_field">*</span>
              </h5>
              {errors.oilAdded && (
                <span className="error-text">This field is required.</span>
              )}
              <div className="row">
                {[0, 0.5, 1, 2, 3, 4, 5].map((amount) => (
                  <div key={amount} className="col mb-2">
                    <button
                      className={`btn btn-outline-secondary w-100 ${
                        oilData.oilAdded === amount.toString() ? "active" : ""
                      }`}
                      onClick={() =>
                        handleChange("oilAdded", amount.toString())
                      }
                    >
                      {amount}
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="section">
              <h5>
                Oil Changed By: <span className="mandory_field">*</span>
              </h5>
              {errors.oilChangedBy && (
                <span className="error-text">This field is required.</span>
              )}

              <div className="row">
                {staffData.map((staff) => (
                  <div className="col-md-3 mb-2" key={staff}>
                    <button
                      className={`btn btn-outline-secondary w-100 ${
                        oilData.oilChangedBy === staff ? "active" : ""
                      }`}
                      onClick={() => handleChange("oilChangedBy", staff)}
                    >
                      {staff === "other"
                        ? "Other (Specify)"
                        : staff.charAt(0).toUpperCase() + staff.slice(1)}
                    </button>
                  </div>
                ))}
              </div>

              {oilData.oilChangedBy === "other" && (
                <div className="col-md-6 mb-3">
                  <h5 className="section_title">
                    Please specify <span className="mandory_field">*</span>
                  </h5>
                  <input
                    type="text"
                    className="form-control custmInput"
                    placeholder="Enter details here..."
                    maxLength={250}
                    defaultValue={oilData.otherOilChangedBy}
                    onChange={(e) =>
                      handleChange("otherOilChangedBy", e.target.value)
                    }
                  />
                  {errors.otherOilChangedBy && (
                    <span className="error-text">This field is required</span>
                  )}
                </div>
              )}
            </div>
          </>
        )}

        <div className="col-md-6 mb-3">
          <h5>
            Picture of closed Oil Cap: <span className="mandory_field">*</span>
          </h5>
          <input
            id="imageInput"
            type="file"
            className="form-control custmInput"
            onChange={handleImageUpload}
            accept=".png, .jpeg, .jpg, .heic"
          />
          {oilData.picture_close_oil_name && (
            <div className="oil_close_cap_div">
              <img
                src={ImageLink + oilData.picture_close_oil_name}
                alt="Uploaded Preview"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />

              <X className="removeBttn" size={18} onClick={removeImage} />
            </div>
          )}
          {errors.picture_close_oil && (
            <span className="error-text">Please Upload Image</span>
          )}
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default OilCheck;
